import { useEffect, useState } from 'react';
import { subscribe } from '../state';
var useSubscribe = function () {
    var _a = useState(Date.now()), setRefresh = _a[1];
    useEffect(function () {
        var unsubscribe = subscribe(function () {
            setRefresh(Date.now());
        });
        return function () {
            unsubscribe();
        };
    }, []);
};
export default useSubscribe;
